import React from 'react'
import SVG from 'react-inlinesvg'
import EventBody from './event-body'
import caretIcon from 'images/caret-down.svg' // in app/assets
import { Collapse } from 'react-collapse'

const toggleEvent = (previewEvent, event) => _ => {
  previewEvent(event)
}

const renderEventImage = event => {
  const { productCardPhoto } = event

  return (
    <div className="overflow-hidden">
      <div
        style={{
          height: '150px',
          backgroundSize: 'cover',
          backgroundPosition: '50%',
          // prettier-ignore
          backgroundImage: `url(${productCardPhoto})`
        }}
      />
    </div>
  )
}

const PreviewButton = ({ previewEvent, event, isExpanded }) => {
  return (
    <button
      id={`expand-panel-${event.id}`}
      onClick={toggleEvent(previewEvent, event)}
      className="flex justify-between w-full"
      data-testid="expand-button"
      aria-expanded={isExpanded}
      aria-controls={`event-${event.id}`}
      style={{ outlineOffset: -3 }}
    >
      <h3 className="text-depths">{event.name}</h3>

      <span
        className="border border-depths rounded-full flex w-32 h-32"
        style={{ opacity: isExpanded ? 0 : 1 }}
      >
        <SVG
          src={caretIcon}
          className="m-auto"
          aria-hidden="true"
          aria-label="caret down"
        />
      </span>
    </button>
  )
}

function Event({ event, preview, previewEvent, ...props }) {
  const isOpened = !!preview

  return (
    <div className="bordered-content p-0 overflow-hidden relative">
      <Collapse isOpened={isOpened}>
        {renderEventImage(event, !!preview)}
      </Collapse>

      <div
        id={`event-${event.id}`}
        className="p-16 md:p-24 overflow-hidden"
        role="region"
      >
        <PreviewButton
          previewEvent={previewEvent}
          event={event}
          isExpanded={isOpened}
        />

        <Collapse isOpened={isOpened}>
          <EventBody
            event={event}
            {...props}
            visible={isOpened}
          />
        </Collapse>
      </div>
    </div>
  )
}

export default Event
